/* @flow */

export type TypeActivity = {|
  tag: string,
  icon: string,
  action: string,
  revisionId: Array<string>,
|};

export type TypeActivities = {|
  [key: string]: TypeActivity,
|};

export const activities: TypeActivities = {
  accessApproved: {
    tag: 'access_approved',
    icon: '#icon-approve',
    action: '',
    revisionId: [],
  },
  activateCostCenter: {
    tag: 'activate_cost_center',
    icon: '#icon-approve',
    action: 'toggleCostCenterStatus',
    revisionId: [],
  },
  accessDeclined: {
    tag: 'access_declined',
    icon: '#icon-declined',
    action: '',
    revisionId: [],
  },
  accessDisabled: {
    tag: 'access_disabled',
    icon: '#icon-remove-from-project',
    action: '',
    revisionId: [],
  },
  accessEnabled: {
    tag: 'access_enabled',
    icon: '#icon-allocate-to-a-project',
    action: '',
    revisionId: [],
  },
  accessRevoked: {
    tag: 'access_revoked',
    icon: '#icon-revoke-user',
    action: '',
    revisionId: [],
  },
  addCompany: {
    tag: 'add_company',
    icon: '#icon-add',
    action: '',
    revisionId: [],
  },
  addCostCenter: {
    tag: 'add_cost_center',
    icon: '#icon-add',
    action: '',
    revisionId: [],
  },
  addLocation: {
    tag: 'add_location',
    icon: '#icon-add',
    action: '',
    revisionId: [],
  },
  addManufacturer: {
    tag: 'add_manufacturer',
    icon: '#icon-add',
    action: '',
    revisionId: [],
  },
  addProduct: {
    tag: 'add_product',
    icon: '#icon-add',
    action: '',
    revisionId: [],
  },
  addProject: {
    tag: 'add_project',
    icon: '#icon-add',
    action: '',
    revisionId: [],
  },
  archiveCostCenter: {
    tag: 'archive_cost_center',
    icon: '#icon-archive',
    action: 'archiveCostCenter',
    revisionId: [],
  },
  archived: {
    tag: 'archived',
    icon: '#icon-archive',
    action: 'archive',
    revisionId: [],
  },
  assetAudit: {
    tag: 'asset_audit',
    icon: '#icon-approve',
    action: 'assetAuditMulti',
    revisionId: [],
  },
  assetDataExported: {
    tag: 'asset_data_exported',
    icon: '#icon-export-asset-data',
    action: '',
    revisionId: [],
  },
  assignCostCenter: {
    tag: 'assign_cost_centers',
    icon: '#icon-assign-cost-center',
    action: 'assignCostCenter',
    revisionId: [],
  },
  assignOwnership: {
    tag: 'request_ownership',
    icon: '#icon-quotes',
    action: 'assignOwnership',
    revisionId: [],
  },
  assignProjectsToCostCenter: {
    tag: 'assign_projects_to_cost_center',
    icon: '#icon-allocate-to-a-project',
    action: 'assignProjectsToCC',
    revisionId: [],
  },
  assignAssetToProject: {
    tag: 'assign_asset_to_project',
    icon: '#icon-allocate-to-a-project',
    action: 'assignAssetToProject',
    revisionId: [],
  },
  assignedAsset: {
    tag: 'assigned_asset',
    icon: '#icon-users',
    action: 'reassign',
    revisionId: ['AppAssetAssignment'],
  },
  assignedCostCenter: {
    tag: 'assigned_cost_center',
    icon: '#icon-assign-cost-center',
    action: '',
    revisionId: [],
  },
  assignedLocation: {
    tag: 'assigned_location',
    icon: '#icon-change-location',
    action: 'changeLocation',
    revisionId: [],
  },

  changeMultipleLocations: {
    tag: 'assigned_location',
    icon: '#icon-change-location',
    action: 'changeMultipleLocations',
    revisionId: [],
  },
  assignedProject: {
    tag: 'assigned_project',
    icon: '#icon-allocate-to-a-project',
    action: 'allocateToProject',
    revisionId: [],
  },
  unassignUser: {
    tag: 'unassign_user',
    icon: '#icon-users',
    action: 'unassignUser',
    revisionId: [],
  },
  assignedUser: {
    tag: 'assigned_user',
    icon: '#icon-users',
    action: 'reassign',
    revisionId: [],
  },
  created: {
    tag: 'created',
    icon: '#icon-add',
    action: '',
    revisionId: [],
  },
  createdAccount: {
    tag: 'created_account',
    icon: '#icon-add',
    action: '',
    revisionId: [],
  },
  createdAsset: {
    tag: 'created_asset',
    icon: '#icon-add',
    action: '',
    revisionId: [],
  },
  createdCostCenter: {
    tag: 'created_cost_center',
    icon: '#icon-add',
    action: '',
    revisionId: [],
  },
  createdManufacturer: {
    tag: 'created_manufacturer',
    icon: '#icon-add',
    action: '',
    revisionId: [],
  },
  createdProduct: {
    tag: 'created_product',
    icon: '#icon-add',
    action: '',
    revisionId: [],
  },
  createdProject: {
    tag: 'created_project',
    icon: '#icon-add',
    action: '',
    revisionId: [],
  },
  declineAssignedProject: {
    tag: 'assign_project_declined',
    icon: '#icon-remove-from-project',
    action: '',
    revisionId: [],
  },
  deleted: {
    tag: 'deleted',
    icon: '#icon-declined',
    action: '',
    revisionId: [],
  },
  detailsUpdated: {
    tag: 'details_updated',
    icon: '#icon-edit',
    action: '',
    revisionId: [],
  },
  disabled: {
    tag: 'disabled',
    icon: '#icon-disable',
    action: '',
    revisionId: [],
  },
  disableCostCenter: {
    tag: 'disable_cost_center',
    icon: '#icon-disable',
    action: 'toggleCostCenterStatus',
    revisionId: [],
  },
  displayUpdated: {
    tag: 'display_updated',
    icon: '#icon-reassign-asset',
    action: '',
    revisionId: [],
  },
  edited: {
    tag: 'edited',
    icon: '#icon-edit',
    action: 'edit',
    revisionId: [
      'AppAsset',
      'AppAccount',
      'created_at',
      'AppContract',
      'AppLocation',
      'AppProject',
      'AppCostCentre',
      'AppManufacturer',
      'AppProduct',
      'AppEventTypeUser',
      'AppEvent',
    ],
  },
  enabled: {
    tag: 'enabled',
    icon: '#icon-approve',
    action: '',
    revisionId: ['is_enabled'],
  },
  ended: {
    tag: 'ended',
    icon: '#icon-end-rental',
    action: '',
    revisionId: [],
  },
  extendContract: {
    tag: 'extendContract',
    icon: '#icon-extend-contract',
    action: 'extendContract',
    revisionId: [],
  },
  extended: {
    tag: 'extended',
    icon: '#icon-extend-rental',
    action: 'extendedRental',
    revisionId: [],
  },
  extensionRequest: {
    tag: 'request_extension',
    icon: '#icon-extend-rental',
    action: 'extendRental',
    revisionId: [],
  },
  extensionApproved: {
    tag: 'request_extension_approved',
    icon: '#icon-approve',
    action: '',
    revisionId: [],
  },
  extensionDeclined: {
    tag: 'request_extension_declined',
    icon: '#icon-declined',
    action: '',
    revisionId: [],
  },
  inviteAccepted: {
    tag: 'invite_accepted',
    icon: '#icon-approve',
    action: '',
    revisionId: [],
  },
  inviteDeclined: {
    tag: 'invite_declined',
    icon: '#icon-declined',
    action: '',
    revisionId: [],
  },
  loggedInAs: {
    tag: 'impersonated_by',
    icon: '#icon-users',
    action: '',
    revisionId: ['AppUser'],
  },
  notificationsUpdated: {
    tag: 'notifications_updated',
    icon: '#icon-notifications',
    action: '',
    revisionId: [],
  },
  ownershipApproved: {
    tag: 'ownership_approved',
    icon: '#icon-approve',
    action: '',
    revisionId: [],
  },
  ownershipDeclined: {
    tag: 'ownership_declined',
    icon: '#icon-declined',
    action: '',
    revisionId: [],
  },
  passwordUpdated: {
    tag: 'password_updated',
    icon: '#icon-password-reset',
    action: '',
    revisionId: [],
  },
  removeCostCenter: {
    tag: 'remove_CostCenters',
    icon: '#icon-remove-cost-center',
    action: 'removeCostCenter',
    revisionId: [],
  },
  removeProjectsFromCostCenter: {
    tag: 'remove_projects_from_cost_center',
    icon: '#icon-remove-from-project',
    action: 'removeProjectsFrommCC',
    revisionId: [],
  },
  removedCostCenter: {
    tag: 'removed_cost_center',
    icon: '#icon-remove-cost-center',
    action: '',
    revisionId: [],
  },
  removedLocation: {
    tag: 'removed_location',
    icon: '#icon-locations',
    action: '',
    revisionId: [],
  },
  removedProject: {
    tag: 'removed_project',
    icon: '#icon-remove-from-project',
    action: 'removeFromProject',
    revisionId: [],
  },
  removedUser: {
    tag: 'removed_user',
    icon: '#icon-revoke-user',
    action: '',
    revisionId: [],
  },
  reportFault: {
    tag: 'report_fault',
    icon: '#icon-fault',
    action: 'reportFault',
    revisionId: [],
  },
  requestAssignedProject: {
    tag: 'request_assigned_project',
    icon: '#icon-allocate-to-a-project',
    action: '',
    revisionId: [],
  },
  requestCalibration: {
    tag: 'request_calibration',
    icon: '#icon-schedule-calibration',
    action: 'scheduleCalibration',
    revisionId: ['AppAssetSchedule'],
  },
  requestOwnership: {
    tag: 'request_ownership',
    icon: '#icon-users',
    action: 'requestOwnership',
    revisionId: [],
  },
  requestQuote: {
    tag: 'request_quote',
    icon: '#icon-quotes',
    action: 'requestQuote',
    revisionId: ['AppAssetQuote'],
  },
  resetAudit: {
    tag: 'reset_audit',
    icon: '#icon-declined',
    action: '',
    revisionId: [],
  },
  roleChanged: {
    tag: 'role_changed',
    icon: '#icon-users',
    action: '',
    revisionId: [],
  },
  scheduleApproved: {
    tag: 'schedule_approved',
    icon: '#icon-approve',
    action: '',
    revisionId: [],
  },
  scheduleDeclined: {
    tag: 'schedule_declined',
    icon: '#icon-declined',
    action: '',
    revisionId: [],
  },
  unarchiveCostCenter: {
    tag: 'unarchive_CostCenter',
    icon: '#icon-unarchive',
    action: 'unarchiveCostCenter',
    revisionId: [],
  },
  unarchived: {
    tag: 'unarchived',
    icon: '#icon-unarchive',
    action: 'unarchive',
    revisionId: [],
  },
  updatedStatus: {
    tag: 'updated_status',
    icon: '#icon-edit',
    action: '',
    revisionId: [],
  },
  userInvited: {
    tag: 'user_invited',
    icon: '#icon-users',
    action: '',
    revisionId: [],
  },
  viewedBy: {
    tag: 'viewed_by',
    icon: '',
    action: '',
    revisionId: [],
  },
};

function getActivityByReviosnId(responseKey: string): ?Object {
  let activityData: ?Object = null;
  Object.keys(activities).forEach(function(key: string): ?string {
    const activity: Object = activities[key];

    activity.revisionId.map((id: string) => {
      if (id === responseKey.replace('\\', '')) {
        activityData = { icon: activity.icon, tag: activity.tag };
      }

      return true;
    });
  });

  return activityData;
}

function getActivityByTag(tag: string): ?Object {
  let activityData: ?Object = null;
  Object.keys(activities).forEach(function(key: string): ?string {
    const activity: Object = activities[key];

    if (tag === activity.tag) {
      activityData = { icon: activity.icon, tag: activity.tag };
    }
  });
  return activityData;
}

function getActivityReasonIcon(tag: string, responseKey: string): ?Object {
  let activityData: ?Object = getActivityByTag(tag);

  if (!activityData) {
    activityData = getActivityByReviosnId(responseKey);

    if (!activityData) {
      activityData = { icon: 'undefined', tag: 'undefined' };
    }
  }

  return activityData;
}

export function getActivity(obj: Object): ?Object {
  const tag: Object = getActivityReasonIcon(obj.activity_tag, obj.revisionable_type);
  /* eslint-disable */
  if (tag) {
    return {
      id: obj.id,
      icon: tag.icon,
      tag: tag.tag,
      date: obj.updated_at,
      user: obj.user_name,
      userId: obj.user_id,
      sent_request_id: obj.sent_request_id,
      can_review: obj.sent_request_id && true,
    };
  }

  return null;
  /* eslint-enable */
}
